export const FLEXIBLE_EXPENSES = ['communicationsAndLeisure', 'foodAndHouseKeeping', 'personalCosts', 'savings'];
